/**
 * Query keys for TanStack Query
 * Centralized key management for cache invalidation
 */

export const listKeys = {
  all: ['lists'],
  lists: () => [...listKeys.all, 'list'],
  list: (id) => [...listKeys.lists(), id],
  user: () => [...listKeys.all, 'user'],
  public: () => [...listKeys.all, 'public'],
  album: (albumId) => [...listKeys.all, 'album', albumId],
  officialCharts: (country) => [...listKeys.all, 'official', country ?? 'global'],
}

export const userKeys = {
  all: ['users'],
  current: () => [...userKeys.all, 'current'],
  byId: (id) => [...userKeys.all, 'detail', id],
  activity: (userId, params) => [...userKeys.all, 'activity', userId, params],
}

export const albumKeys = {
  all: ['albums'],
  lists: () => [...albumKeys.all, 'list'],
  list: (filters) => [...albumKeys.lists(), filters],
  detail: (id) => [...albumKeys.all, 'detail', id],
  byArtist: (artistId) => [...albumKeys.all, 'artist', artistId],
  popular: (params) => [...albumKeys.all, 'popular', params],
  newReleases: (params) => [...albumKeys.all, 'new', params],
  currentReleases: (params) => [...albumKeys.all, 'current', params],
  incomingReleases: (params) => [...albumKeys.all, 'incoming', params],
}

export const artistKeys = {
  all: ['artists'],
  detail: (id) => [...artistKeys.all, 'detail', id],
  search: (query) => [...artistKeys.all, 'search', query],
}

export const concertKeys = {
  all: ['concerts'],
  lists: () => [...concertKeys.all, 'list'],
  list: (filters) => [...concertKeys.lists(), filters],
  detail: (id) => [...concertKeys.all, 'detail', id],
}

export const festivalKeys = {
  all: ['festivals'],
  lists: () => [...festivalKeys.all, 'list'],
  list: (filters) => [...festivalKeys.lists(), filters],
  detail: (id) => [...festivalKeys.all, 'detail', id],
  edition: (id) => [...festivalKeys.all, 'edition', id],
  compare: (ids) => [...festivalKeys.all, 'compare', [...ids].sort().join(',')],
}

export const voteKeys = {
  all: ['votes'],
  forItem: (type, id) => [...voteKeys.all, type, id],
}

export const attendanceKeys = {
  all: ['attendance'],
  edition: (editionId) => [...attendanceKeys.all, 'edition', editionId],
  user: (userId, status) => [...attendanceKeys.all, 'user', userId, status],
}

export const statsKeys = {
  all: ['stats'],
  platform: () => [...statsKeys.all, 'platform'],
}

export const threadKeys = {
  all: ['threads'],
  edition: (editionId) => [...threadKeys.all, 'edition', editionId],
  detail: (threadId) => [...threadKeys.all, 'detail', threadId],
}
